import { render, staticRenderFns } from "./FacturacionesIndex.vue?vue&type=template&id=6ac22b57"
import script from "./FacturacionesIndex.vue?vue&type=script&lang=js"
export * from "./FacturacionesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports